module.exports = __webpack_public_path__ + "static/img/YJJ.2c2d2546.png";